module.exports = __webpack_public_path__ + "static/media/view1.688e90d2.jpg";